import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: ":schoolId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "teacher-courses" */ "./components"),
      import(
        /* webpackChunkName: "teacher-courses" */ "LearningCourses/modules/LearningCoursesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "learningCourses",
        reducer,
      });

      return component;
    })
  ),
});
